<template>
  <el-popover
    ref="popover"
    placement="right"
    trigger="click"
    popper-class="bpm-icon-choose"
    width="320px"
    :visible-arrow="false"
  >

    <div slot="reference" class="icon-now">
      <template v-if="isNaN(iconIndex)">
        <el-tooltip class="item" effect="dark" content="点击图标可进行修改" placement="top">
          <img :src="iconIndex">
        </el-tooltip>
      </template>
      <template v-else>
        <el-tooltip class="item" effect="dark" content="点击图标可进行修改" placement="top">
          <svg-icon :icon-class="'form-icon-' + iconIndex" />
        </el-tooltip>
      </template>
    </div>
    <div class="icon-container">
      <div class="icon-tab">
        <p :class="{ active: type === 1 }" @click="type = 1">选择默认图标</p>
        <p :class="{ active: type === 2 }" @click="type = 2">上传自定义图标</p>
      </div>
      <div class="icon-content">
        <div v-show="type === 1" class="icon-list">
          <svg-icon
            v-for="i in 25"
            :key="i"
            :icon-class="'form-icon-' + (i - 1)"
            @click.native="chooseIcon(i - 1)"
          />
        </div>
        <div v-show="type === 2" style="padding: 0px 12px">
          <my-upload
            :ref="'upload'"
            :multiple="false"
            :list-type="'picture'"
            :file-list="[]"
            :show-file-list="false"
            :allow-size="5 * 1024"
            :allow-type="['.jpg', '.JPG', '.png', '.png', '.jpeg', '.svg']"
            @handleRemove="handleUploadRemove(arguments)"
            @uploadSuccess="uploadSelfPoster(arguments)"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <div v-else class="avatar-uploader-icon">
              <svg-icon icon-class="approval-upload" />
              <p>上传图片</p>
            </div>
          </my-upload>
          <p class="suggest">
            建议上传有底色图标，支持格式：png、 jpg、 jpeg、 svg，建议尺寸250*250
            px，大小不超过5M。
          </p>
        </div>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'CompanyChoose',
  model: {
    prop: 'icon', // 对应 props msg
    event: 'change'
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      disabled: false,
      type: 1, // 类型
      iconIndex: '0', // 当前icon
      imageUrl: '' // 图片链接
    }
  },
  watch: {
    type(newVal) {
      switch (newVal) {
        case 1:this.$emit('changeIconType', 0); break
        case 2:this.$emit('changeIconType', 1); break
      }
    },
    icon(newVal) {
      // 编辑回显
      this.iconIndex = newVal
    }
  },
  created() {},
  mounted() {
    // 初始选择第一个
    this.$emit('change', this.iconIndex)
  },
  methods: {
    // 选择图标
    chooseIcon(index) {
      this.iconIndex = String(index)
      this.imageUrl = ''
      this.$emit('change', this.iconIndex)
      try {
        this.$refs.popover.doClose()
      } catch (err) {
        console.log(err)
      }
    },
    // 上传成功回调用，多文件用,分割
    uploadSelfPoster(files) {
      const res = files[0]
      const file = files[1]
      if (res && res.code === 200 && res.data && file.name) {
        this.iconIndex = res.data
        this.imageUrl = res.data
        this.$emit('change', this.iconIndex)
        this.$nextTick(() => {
          try {
            this.$refs.popover.doClose()
          } catch (err) {
            console.log(err)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-now {
  display: inline-block;
  width: 48px;
  height: 48px;
  border:1px dashed rgb(230, 224, 224);
  background-color: #f5f9ff;
  border-radius: 6px;
  overflow: hidden;
  &:hover{
  border:1px dashed #2c51ef;
  }
  cursor: pointer;
  svg {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
    border-radius: 6px;
    // background-color: #f5f9ff;
    // &:hover {
    //   border: 1px dashed #2c51ef;
    // }
  }
  img {
    width: 48px;
    height: auto;
  }
}
.bpm-icon-choose {
  .icon-container {
    .icon-tab {
      display: flex;
      align-items: center;
      background: #f2f3f5;
      padding: 4px;
      > p {
        flex: 1;
        font-size: 14px;
        text-align: center;
        height: 32px;
        line-height: 32px;
        font-weight: 400;
        color: #4e5969;
        border-radius: 4px;
        cursor: pointer;
        &.active {
          background: #ffffff;
          color: #2f4bdd;
          font-weight: 500;
        }
      }
    }
    .icon-content {
      width: 280px;
      min-height: 240px;
      padding-top: 16px;
      .icon-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        svg {
          cursor: pointer;
          width: 48px;
          height: 48px;
          min-width: 48px;
          min-height: 48px;
          &:hover {
            border-radius: 4px;
            background: rgba(44, 81, 239, 0.07);
          }
        }
      }
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      svg {
        font-size: 16px;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: #adb5bd;
        line-height: 20px;
        padding-top: 8px;
      }
    }
    .avatar {
      max-width: 100px;
      height: auto;
      display: block;
      border-radius: 4px;
    }
    .suggest {
      font-size: 12px;
      font-weight: 400;
      color: #c1c1c1;
      line-height: 20px;
    }
  }
}
</style>
